import { useQuery } from "@tanstack/react-query";

import { useAuth } from "common/context/AuthContext";

import { get } from "../helpers/HTTP";

import type { Workspace } from "../types";

async function getWorkspacesRequest(): Promise<Workspace[]> {
  return (await get(`workspaces`)).workspaces;
}

export default function useWorkspaces() {
  const { isAuthorized } = useAuth();

  const { data: workspaces, refetch: refetchWorkspaces } = useQuery({
    queryKey: ["workspaces"],
    queryFn: getWorkspacesRequest,
    refetchOnMount: false,
    enabled: !!isAuthorized,
  });

  return {
    workspaces,
    refetchWorkspaces,
  };
}
